export default __webpack_public_path__ + "static/media-cd37c4cc8ce10ac733732c2ba34e10ec.gif";